import { useCallback, useEffect, useState } from 'react'
import { AspenPatientProvidersService, PaginatedDTO_PatientProviderDTO_ } from '../client'
import { CancelablePromise } from '../client/core/CancelablePromise'

export const usePatientProviders = ({ patientId, providerId }: { patientId?: string; providerId?: string }) => {
    const [patientProviders, setPatientProviders] = useState<PaginatedDTO_PatientProviderDTO_ | null>(null)
    const [loading, setLoading] = useState<boolean>(true)
    const [error, setError] = useState<string | null>(null)

    const fetchPatientProviders = useCallback(async () => {
        setLoading(true)
        setError(null)
        try {
            const response: CancelablePromise<PaginatedDTO_PatientProviderDTO_> = AspenPatientProvidersService.indexPatientProvidersGet({
                patientId,
                providerId
            })
            const data = await response
            setPatientProviders(data)
        } catch (err) {
            setError('Failed to fetch patient providers data')
        } finally {
            setLoading(false)
        }
    }, [patientId, providerId])

    useEffect(() => {
        fetchPatientProviders()
    }, [fetchPatientProviders])

    return { patientProviders, loading, error, refetch: fetchPatientProviders }
}
